module.exports = __webpack_public_path__ + "static/media/grey-long-arrow.6c10416e.svg";